export const ARCHIVING_DRAGGABLE_OPTIONS = {
  animation: 150,
  handle: '.drag-handle',
  ghostClass: 'bg-[var(--theme-secondary-tint)]',
} as const;
